import { render } from "./Supporting.vue?vue&type=template&id=5812d894"
import script from "./Supporting.vue?vue&type=script&lang=js"
export * from "./Supporting.vue?vue&type=script&lang=js"
script.render = render

export default script